/**
 * Константы для AdvisorObject
 * Централизованное хранение всех магических значений
 */
export const ADVISOR_CONSTANTS = {
  // Геометрия
  DEFAULT_RADIUS: 1500,
  DEFAULT_COLOR: 0xff9326,
  GEOMETRY_SEGMENTS_WIDTH: 32,
  GEOMETRY_SEGMENTS_HEIGHT: 16,
  GEOMETRY_PHI_START: 0,
  GEOMETRY_PHI_LENGTH: Math.PI * 2,
  GEOMETRY_THETA_START: 0,
  GEOMETRY_THETA_LENGTH: Math.PI / 3,

  // Текстуры
  TEXTURE_SIZE: 256,
  REFLECTION_TEXTURE_R: 100,
  REFLECTION_TEXTURE_G: 150,
  REFLECTION_TEXTURE_B: 200,
  REFLECTION_TEXTURE_A: 255,
} as const
